// ------------------------------------------------------------------------------
// This is place holder code until a better generated/self describing CS/Typescript object model can be created
// The reason we aren't using the 'factory' is because we don't want the 'truth' to live in office-online-ui
// ------------------------------------------------------------------------------
import { SchemaObject } from '@augloop/types-core';
/**
 * @deprecated
 */
export class Tile extends SchemaObject {
    constructor(id) {
        super();
        /**
         * Identifier of the tile.
         */
        this.Id = null;
        this.Id = id;
    }
}
/**
 * Abstract tile implementation.
 * @deprecated
 */
export class Tile$1 extends Tile {
    constructor(id, content) {
        super(id);
        /**
         * Content of the tile.
         */
        this.Content = null;
        this.Content = content;
    }
}
/**
 * Possible values of Tile Type
 * @deprecated
 */
export var TileType;
(function (TileType) {
    TileType[TileType["Unknown"] = 0] = "Unknown";
    TileType[TileType["Text"] = 1] = "Text";
    TileType[TileType["Slide"] = 2] = "Slide";
})(TileType || (TileType = {}));
/* eslint-enable @typescript-eslint/naming-convention */
/**
 * Represents formatted range of text.
 * @deprecated
 */
export class FormattedSpan {
    constructor(start, length, fontWeight, italic, underline, capitalization, fontSize, color, styleName) {
        /**
         * Start index of range.
         */
        this.Start = 0;
        /**
         * Length of range.
         */
        this.Length = 0;
        /**
         * Font weight of a span.
         */
        this.FontWeight = FontWeight.DontCare;
        /**
         * Is entire span italic.
         */
        this.Italic = false;
        /**
         * Does entire span have underline.
         */
        this.Underline = UnderlineType.None;
        /**
         * Does entire span has all caps applied.
         */
        this.Capitalization = CapsType.NoCaps;
        /**
         * Font size in span. We return font that is most used inside span.
         */
        this.FontSize = 0;
        /**
         * Font color in span. Every byte has one of RGBA properties.
         */
        this.Color = 0;
        /**
         * Style name applied to span.
         */
        this.StyleName = null;
        this.Start = start;
        this.Length = length;
        this.FontWeight = fontWeight;
        this.Italic = italic;
        this.Underline = underline;
        this.Capitalization = capitalization;
        this.FontSize = fontSize;
        this.Color = color;
        this.StyleName = styleName;
    }
}
/**
 * @deprecated
 */
export class TextTile extends Tile$1 {
    constructor(id, content, language) {
        super(id, content);
        /**
         * Language of the text tile.
         */
        this.Language = null;
        /**
         * Revision Id used to identify if tile content has changed.
         */
        this.RevisionId = null;
        /**
         * Monotonically increasing sequence number to allow for chronological ordering of tile content changes.
         */
        this.RevisionSequence = 0;
        /**
         * Indentation of paragraph. If there is no indentation the value is 0
         */
        this.Indentation = 0;
        /**
         * Outline level of the paragraph as represented in navigation.
         */
        this.OutlineLevel = 0;
        /**
         * Type of the list that the paragraph is part of.
         */
        this.ListType = ListType.Number;
        /**
         * Name of the style applied to paragraph.
         */
        this.Alignment = Alignment.Left;
        /**
         * Text ranges/runs containing formatting information. Ranges are expected to be preserved in reading order.
         * There should be no overlapping between ranges.
         * It is allowed to cover only part of the text with formatted ranges. Rest of the text is supposed to have default formatting.
         * E.g. in a 100-character text tile it would be ok to have a single FormattedRange with start=35 and length=10;
         * this would be equivalent to also having FormattedRanges covering s=0, l=35 and s=45, l=55 with none of the (all-optional)
         * properties set.
         */
        this.FormattedRanges = null;
        this.Language = language;
    }
}
/**
 * Enum containing possible capitalization values.
 * @deprecated
 */
export var CapsType;
(function (CapsType) {
    CapsType[CapsType["NoCaps"] = 0] = "NoCaps";
    CapsType[CapsType["SmallCaps"] = 1] = "SmallCaps";
    CapsType[CapsType["AllCaps"] = 2] = "AllCaps";
    CapsType[CapsType["AllPetiteCaps"] = 3] = "AllPetiteCaps";
    CapsType[CapsType["PetiteCaps"] = 4] = "PetiteCaps";
    CapsType[CapsType["Unicase"] = 5] = "Unicase";
    CapsType[CapsType["Titling"] = 6] = "Titling";
    CapsType[CapsType["Other"] = 7] = "Other";
})(CapsType || (CapsType = {}));
/**
 * Enum containing possible underline values.
 * @deprecated
 */
export var UnderlineType;
(function (UnderlineType) {
    UnderlineType[UnderlineType["None"] = 0] = "None";
    UnderlineType[UnderlineType["Words"] = 1] = "Words";
    UnderlineType[UnderlineType["SingleLine"] = 2] = "SingleLine";
    UnderlineType[UnderlineType["DoubleLine"] = 3] = "DoubleLine";
    UnderlineType[UnderlineType["HeavyLine"] = 4] = "HeavyLine";
    UnderlineType[UnderlineType["DottedLine"] = 5] = "DottedLine";
    UnderlineType[UnderlineType["DottedHeavyLine"] = 6] = "DottedHeavyLine";
    UnderlineType[UnderlineType["DashLine"] = 7] = "DashLine";
    UnderlineType[UnderlineType["DashHeavyLine"] = 8] = "DashHeavyLine";
    UnderlineType[UnderlineType["DashLongLine"] = 9] = "DashLongLine";
    UnderlineType[UnderlineType["DashLongHeavyLine"] = 10] = "DashLongHeavyLine";
    UnderlineType[UnderlineType["DotDashLine"] = 11] = "DotDashLine";
    UnderlineType[UnderlineType["DotDashHeavyLine"] = 12] = "DotDashHeavyLine";
    UnderlineType[UnderlineType["DotDotDashLine"] = 13] = "DotDotDashLine";
    UnderlineType[UnderlineType["DotDotDashHeavyLine"] = 14] = "DotDotDashHeavyLine";
    UnderlineType[UnderlineType["WavyLine"] = 15] = "WavyLine";
    UnderlineType[UnderlineType["WavyHeavyLine"] = 16] = "WavyHeavyLine";
    UnderlineType[UnderlineType["WavyDoubleLine"] = 17] = "WavyDoubleLine";
})(UnderlineType || (UnderlineType = {}));
/**
 * Enum containing possible font weight values.
 * @deprecated
 */
export var FontWeight;
(function (FontWeight) {
    FontWeight[FontWeight["DontCare"] = 0] = "DontCare";
    FontWeight[FontWeight["Thin"] = 1] = "Thin";
    FontWeight[FontWeight["ExtraLight"] = 2] = "ExtraLight";
    FontWeight[FontWeight["Light"] = 3] = "Light";
    FontWeight[FontWeight["Normal"] = 4] = "Normal";
    FontWeight[FontWeight["Medium"] = 5] = "Medium";
    FontWeight[FontWeight["SemiBold"] = 6] = "SemiBold";
    FontWeight[FontWeight["Bold"] = 7] = "Bold";
    FontWeight[FontWeight["ExtraBold"] = 8] = "ExtraBold";
    FontWeight[FontWeight["Heavy"] = 9] = "Heavy";
})(FontWeight || (FontWeight = {}));
/**
 * Enum containing possible list types
 * @deprecated
 */
export var ListType;
(function (ListType) {
    ListType[ListType["Number"] = 0] = "Number";
    ListType[ListType["Bullet"] = 1] = "Bullet";
    ListType[ListType["Lim"] = 13] = "Lim";
    ListType[ListType["Nil"] = 14] = "Nil";
    ListType[ListType["Any"] = 15] = "Any";
    ListType[ListType["NoList"] = 16] = "NoList";
    ListType[ListType["Invalid"] = 42] = "Invalid";
})(ListType || (ListType = {}));
/**
 * Enum containing possible paragraph alignment
 * @deprecated
 */
export var Alignment;
(function (Alignment) {
    Alignment[Alignment["Left"] = 0] = "Left";
    Alignment[Alignment["Right"] = 1] = "Right";
    Alignment[Alignment["Center"] = 2] = "Center";
    Alignment[Alignment["Justified"] = 3] = "Justified";
    Alignment[Alignment["Other"] = 4] = "Other";
    Alignment[Alignment["None"] = 5] = "None";
})(Alignment || (Alignment = {}));
/**
 * V1 Support - Will not be preserved in V2 in the current form
 * @deprecated
 */
export class Lambda {
}
/**
 * @deprecated
 */
export class DataObject {
    constructor(type, data) {
        this.type = type;
        this.data = data;
    }
}
/**
 * Represents a Lambda Exception. A way of expressing what went wrong in a Lambda.
 * @deprecated
 */
export class LambdaException {
    constructor(errorCode, message, data) {
        this.exceptionType = errorCode;
        this.message = message;
        this.data = data;
    }
    /**
     * Based on message-schema.proto:
     * enum ExceptionType {
     * 	Unknown = 0;
     * 	NoOutput = 1;
     * 	Authentication = 2;
     * 	JoinTimedOut = 3;
     * 	LambdaThrow = 4;
     * 	LambdaErrorCallback = 5;
     * }
     */
    static exceptionTypeToString(errorCode) {
        switch (errorCode) {
            case 0:
                return 'Unknown';
            case 1:
                return 'NoOutput';
            case 2:
                return 'Authentication';
            case 3:
                return 'JoinTimedOut';
            case 4:
                return 'LambdaThrow';
            case 5:
                return 'LambdaErrorCallback';
            default:
                return 'Invalid Error Type';
        }
    }
    /**
     * Parse byte array representation of exception data into string.
     *
     * @param data   charCode array
     * @returns string representation of charCode array
     */
    static parseExceptionData(data) {
        let exceptionData = '';
        try {
            exceptionData = String.fromCharCode.apply(null, data);
        }
        catch (ex) {
            return 'Failed to decode exception data:' + ex.toString();
        }
        return exceptionData;
    }
}
/**
 * @deprecated
 */
export class AugLoopStandardSchema {
    constructor(proto, schemas) {
        this._proto = proto;
        this._schemas = schemas;
    }
    get proto() {
        return this._proto;
    }
    get schemas() {
        return this._schemas;
    }
    registerSchemas(augLoopRuntime) {
        return augLoopRuntime.registerSchemas({
            proto: this.proto,
            schemaNames: this.schemas,
        });
    }
}
/**
 * @deprecated
 */
export class CrudAugLoopStandardSchema {
    constructor(tileName, tileSchema) {
        this._tileName = tileName;
        this._tileSchema = tileSchema;
        this._addedSchemaName = tileName + 'Added';
        this._attachedSchemaName = tileName + 'Attached';
        this._changedSchemaName = tileName + 'Changed';
        this._deletedSchemaName = tileName + 'Deleted';
    }
    get tileName() {
        return this._tileName;
    }
    get tileSchema() {
        return this._tileSchema;
    }
    get addedSchemaName() {
        return this._addedSchemaName;
    }
    get attachedSchemaName() {
        return this._attachedSchemaName;
    }
    get changedSchemaName() {
        return this._changedSchemaName;
    }
    get deletedSchemaName() {
        return this._deletedSchemaName;
    }
    registerSchemas(augLoopRuntime) {
        const proto = 'syntax="proto3";'
            + 'message '
            + this.addedSchemaName
            + ' '
            + this.tileSchema
            + '; '
            + 'message '
            + this.changedSchemaName
            + ' '
            + this.tileSchema
            + '; '
            + 'message '
            + this.attachedSchemaName
            + ' '
            + this.tileSchema
            + '; '
            + 'message '
            + this.deletedSchemaName
            + ' '
            + this.tileSchema
            + '; ';
        const schemas = [this.addedSchemaName, this.changedSchemaName, this.attachedSchemaName, this.deletedSchemaName];
        return augLoopRuntime.registerSchemas({
            proto,
            schemaNames: schemas,
        });
    }
}
//# sourceMappingURL=DeprecatedTypes.js.map